import { createContext } from 'react'

const userCreationContext = createContext();

export default userCreationContext;
